import gql from 'graphql-tag';

export const RATE_FIELDS = gql`
	fragment RateFields on Rate {
		rateMatrixId
		addDate
		bandwidthPercentage
		greenPercentage
		baseRate
		billingMethod
		customerId
		displayRate
		displayRateNoSalesTax
		displayRate500
		displayRate1000
		displayRate2000
		logo
		name
		productId
		productName
		rate
		rate500
		rate1000
		rate2000
		savings
		supplierId
		stateId
		serviceTypeId
		term
		termName
		usageAdjustments
		tosPath
		planName
		disclaimerPath
		extra
		salesTax
		rateClass
		rateCodeId
		loadFactor
		puct
		legalEntityName
		residentialServiceEmail
		website
		address1
		address2
		city
		stateShort
		zipCode
		planId
		usageAdjustment
		eflPath
		rateAddDate
		premium
		yracPath
		monthlyServiceFee
		commission
		cancellationPenaltyDesc
		phone3
		loadFactorNote
		contractAgentFinalMargin
		showTaxId
		effectiveDate
		allowMatrixRenewal
		maxNumLocations
		restrictionsNote
		isAffectedByMarginCapSplit
		amountMarginAffectedByCapSplit
		upfrontPaymentRule
		residualPaymentRule
		paymentAmount
		marginSplitRule
		marginCapRule
		compensationRuleDescription
		units
		isUsingAgentMarginCap
		displayAgentMarginCap
		isBillRequiredForEnrollment
		showResidentialPreferredContactMethod
		showSsn
		showDob
		showTaxExemptReasons
		commissionOptions {
			percentage
			estTotalCommission
			estAnnualPayment
			estFirstPayment
			estFirstPaymentDescription
			commissionPayPlanTypeId
			commissionPayPlanType {
				description
				header
				details
			}
		}
	}
`;

export const VIEW_PENDING_FLOW_CHECK_FIELDS = gql`
	fragment ViewPendingFlowCheckFields on ViewPendingFlowCheck {
		supplierId
		contractId
		contractNum
		contractLocationId
		supplierAccountNumber
		supplierStatus
		currentStatus
		status
		currentDisplayStatus
		supplierDropDate
		dropDate
		supplierStatusDescription
		supplierReinstatementDate
		reinstatementDate
		pendingFlowCheckStatusId
		pendingFlowCheckStatusName
		supplierCustomerName
		errors
		units
		effectiveDate
		expirationDate
		accountDisplayStatus
		utilityAccountNums
		supplierName
	}
`;

export const CORE_LOGGEDINUSER_FIELDS = gql`
	fragment CoreLoggedInUserFields on User {
		userId
		billReaderUserId
		agentId
		roleId
		defaultRateSort
		defaultGasUnit
		defaultElectricityUnit
		isPasswordExpired
		supplierId
		phone
		fname
		middle
		lname
		isActive
		isAdmin
		isSaas
		isOwner
		isFinance
		isOperations
		companyId
		defaultUserGridConfigId
		showTermsOfService
		fullName
		showCompliance
		showIdDocument
		isCommissionUser
		lastLogin
		showAdvisorAcademyTour
		externalId
		helpScoutSignature
		email
		gridConfigs {
			id
			name
			gridId
			isGlobal
			isDefault
			states
			sortOrder
		}
		role {
			roleId
			name
			level
			permissions {
				name
			}
		}
		supplier {
			licensePlans {
				id
			}
		}
		agent {
			name
			supportEmail
			addDate
			agentId
			parentId
			brotherId
			hasFailedPayment
			useSupportSystem
			useReports
			usePayableReports
			isPaidIndividually
			isActive
			isFraudulent
			isEnterprise
			isEmployee
			holdPayables
			holdEnrollments
			isNewBroker
			isInHouseIndirectSale
			commissionRate
			commissionRate2
			commissionRate3
			residentialCommissionRate
			residentialCommissionRate2
			showUtilityCheck
			showCapSplitWarning
			commissionPayPlanTypeId
			marketOpportunitiesAlertEffectiveDate
			residentialContractRatio
			commissionSplitTypeId
			useAgentDiscountProgram
			commissionSplitElectricityBufferMarginParent
			commissionSplitGasBufferMarginParent
			commissionSplitElectricityBufferMarginBrother
			commissionSplitGasBufferMarginBrother
			phone
			customerCompany
			volume
			discountFactor
			futureCommissionAmount
			totalUpfrontCommissionPaidAmount
			flowedTermValue
			maxReversibleCommission
			maxReversibleCommissionOverride
			negativeBalance
			reversibleCommission
			currMonthEstimatedCommission
			lastMonthPaidCommission
			showFinancialProfile
			dropRatio
			hasConfirmedContracts
			showBrokerCrm
			showCustomerCrm
			showNewYorkCommercialMatrix
			showQuoteForecastedCommission
			showEnergyPortal
			useStaticCommissionRate
			darkDisplayLogoAttachment: displayLogoAttachment(criteria: { defaultAgentLogoType: DARK, defaultCompanyLogoType: NAVBAR }) {
				attachmentId
			}
			lightDisplayLogoAttachment: displayLogoAttachment(criteria: { defaultAgentLogoType: LIGHT, defaultCompanyLogoType: EMAIL }) {
				attachmentId
			}
			commissionPayPlanOptionStats {
				description
				maxRate
			}
			discountProgram {
				name
				rate
				className1
				className2
				className3
			}
			agentLicensePlans {
				id
				licensePlan {
					name
					years
					parents {
						id
					}
				}
			}
			subAgents(sort: "name", limitOverride: true) {
				agentId
				name
				isNewBroker
			}
			parent {
				agentId
				name
				customerCompany
				useSupportSystem
				useReports
				usePayableReports
				supportEmail
				isNewBroker
				isEnterprise
				showEnergyPortal
				commissionSplitTypeId
				useAgentDiscountProgram
				discountFactor
				showFinancialProfile
				dropRatio
				showNewYorkCommercialMatrix
				showQuoteForecastedCommission
				logins {
					fname
					middle
					lname
					isPrimary
					addDate
					email
				}
				themes {
					agentThemeCategoryId
					primary
					secondary
					tertiary1
					tertiary2
					tertiary3
					logoAttachmentId
					useParentNameAsCompanyNameForProposal
				}
			}
			logins {
				fname
				middle
				lname
				isPrimary
				addDate
				email
			}
			themes {
				agentThemeCategoryId
				primary
				secondary
				tertiary1
				tertiary2
				tertiary3
				logoAttachmentId
				useParentNameAsCompanyNameForProposal
			}
			bankAccounts {
				id
				isInvalid
			}
		}
		company {
			name
			isDecoupled
			isSaas
			allowCommercialMatrixQuote
			allowResidentialMatrixQuote
			allowInstantQuote
			residentialQuoteRequiresPOA
			showCustomerPii
			showReports
			showSapExternalId
			showCustomerPii
			showResidentialQuoteLinkEmail
			showResidentialQuotePlanEmail
			showResidentialSavings
			showResidentialBestPlan
			showResidentialQuoteLinkCustomizeTextBox
			houseAccount {
				agentId
				name
			}
			licensePlans {
				id
			}
			defaultNavbarLogoAttachment {
				attachmentId
				originalName
				path
			}
			defaultFooterLogoAttachment {
				attachmentId
				originalName
				path
			}
			defaultEnergyPortalLogoAttachment {
				attachmentId
				originalName
				path
			}
		}
		menus(criteria: { menuTypeId: "588f179571db717b01723a85369a053c", isActive: true }, sort: "sortOrder") {
			menuId
			menuTypeId
			permissions
			eventName
			queryString
			className
			name
			idName
			sortOrder
			parentId
			iconClassName
		}
		accountManager {
			id
		}
	}
`;

export const CORE_QUOTE_PAGE_AGENT_FIELDS = gql`
	fragment CoreQuotePageAgentFields on Agent {
		agentId
		isActive
		name
		commissionRate
		commissionRate2
		residentialCommissionRate
		residentialCommissionRate2
		showUtilityCheck
		showCapSplitWarning
		isNewBroker
		showNewYorkCommercialMatrix
		companyId
		company {
			isSaas
			isDecoupled
			showResidentialQuoteLinkEmail
			showResidentialQuotePlanEmail
			showResidentialSavings
			showResidentialBestPlan
			showResidentialQuoteLinkCustomizeTextBox
			autoSubmitResidentialEnrollment
			showCustomerPii
			licensePlans {
				id
			}
			houseAccount {
				agentId
				name
			}
		}
		parent {
			commissionSplitTypeId
			showNewYorkCommercialMatrix
			logins {
				userId
				fname
				middle
				lname
				isPrimary
				addDate
				email
			}
		}
		logins {
			userId
			fname
			middle
			lname
			isPrimary
			addDate
			email
		}
	}
`;

export const CORE_QUOTE_PAGE_CONTRACT_FIELDS = gql`
	fragment CoreQuotePageContractFields on Contract {
		contractId
		contractNum
		rate
		term
		margin
		bufferMargin
		effectiveDate
		expirationDate
		annualUsage
		serviceTypeId
		awardDate
		uploadDate
		supplierId
		stateId
		previousRate
		agentId
		rfqSessionId
		customerId
		status
		confirmationDate
		switchTypeCode
		loadFactor
		networkLoadFactor
		customLoadFactor
		hasUsage
		plc
		networkPlc
		moveInType
		isNewBrokerAuction
		sentAutomatedRenewalEmailDate
		commissionPayPlanId
		isRenewal
		baseRateOverride
		dwellingType
		isResidential
		previousContract {
			supplierId
			term
		}
		attachments {
			attachmentId
			attachmentTypeId
			esignDocument {
				esignId
				esignDocumentId
				esign {
					signatureDate
					signature
					isManualUpload
				}
			}
			companyAttachmentType {
				validDays
			}
		}
	}
`;

export const CORE_QUOTE_PAGE_CUSTOMER_FIELDS = gql`
	fragment CoreQuotePageCustomerFields on Customer {
		customerId
		dbaName
		contactFname
		contactMiddle
		contactLname
		contactTitle
		email
		address1
		address2
		zipCode
		stateId
		city
		phone
		phone2
		fax
		mobile
		taxId
		dob
		language
		ssn
		phoneCountryId
		phone2CountryId
		mobileCountryId
		faxCountryId
		billingAddress1
		billingAddress2
		billingZipCode
		billingCity
		billingStateId
		billingState {
			stateShort
			stateLong
			countryId
		}
		state {
			stateShort
			stateLong
			countryId
			country {
				symbol
				isoCode
				symbol2
			}
		}
		userNotificationCategories {
			id
		}
	}
`;

export const CORE_CONTRACT_EDIT_AGENT = gql`
	fragment CoreContractEditAgentFields on Agent {
		agentId
		parentId
		name
		discountFactor
		isNewBroker
		parent {
			discountFactor
			commissionSplitTypeId
		}
		promoCodes(sort: "isActive desc, slug") {
			id
			isActive
			slug
		}
		logins {
			userId
			fname
			middle
			lname
			isPrimary
			addDate
			email
		}
	}
`;

export const CORE_VIEW_LEAD_FIELDS = gql`
	fragment CoreViewLeadFields on ViewLead {
		id
		dbaName
		address1
		address2
		city
		stateId
		stateLong
		stateShort
		zipCode
		priority
		tierLevel
		website
		profileDescription
		leadStatusId
		leadStatusName
		leadStatusReasonTypeId
		leadStatusReasonTypeName
		leadStatusReasonNote
		leadStatusCategoryId
		leadBusinessTypeId
		leadBusinessTypeName
		linkedInUrl
		cssClass
		assignedToAgentId
		assignedToAgentName
		contactFname
		contactLname
		contactMobile
		contactMobileCountryId
		contactEmail
		reminderCount
		reminderFutureCount
		reminderPastCount
		agentId
		agentName
		amtHasDuplicate
		amtIsDuplicate
		addDate
		isIceBoxed
		leadCategoryId
		leadCategoryName
		leadSource
	}
`;

export const CORE_VIEW_AGENT_REFERRAL_SERVICE_FIELDS = gql`
	fragment CoreViewAgentReferralServiceFields on ViewAgentReferralService {
		id
		serviceId
		serviceName
		serviceStates
		agentReferralServiceProfileId
		dbaName
		title
		summary
		description
		imageIconAttachmentId
	}
`;
